import React from 'react';
import { CheckCircle2, XCircle, Hash } from 'lucide-react';

// Categorias de plano do CRM x serviços da Claro
export const CATEGORIAS_SERVICO = {
  tv: { label: 'TV', regex: /PTV|^TV|TV\b/i },
  internet: { label: 'Internet', regex: /VIRTUA|GPON|INTERNET|BANDA/i },
  fixo: { label: 'Fone', regex: /VOIP|FONE|TELEFON/i },
};

export const vendavelNaCategoria = (servicos, chave) => {
  const cat = CATEGORIAS_SERVICO[chave];
  const lista = (servicos || []).filter((s) => cat.regex.test(s.tipo || ''));
  if (!lista.length) return null; // Claro não informou esse tipo
  return lista.some((s) => s.tecnica && s.comercial);
};

export const ServicoChip = ({ s, testid }) => {
  const ok = s.tecnica && s.comercial;
  return (
    <span className={`inline-flex items-center gap-1 rounded-md px-1.5 py-0.5 text-[11px] font-semibold ${ok ? 'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/40 dark:text-emerald-300' : 'bg-red-100 text-red-600 dark:bg-red-900/40 dark:text-red-300'}`}
      title={`Técnica: ${s.tecnica ? 'SIM' : 'NÃO'} • Comercial: ${s.comercial ? 'SIM' : 'NÃO'}`} data-testid={testid}>
      {ok ? <CheckCircle2 className="w-3 h-3" /> : <XCircle className="w-3 h-3" />} {s.tipo}
    </span>
  );
};

export const HpChip = ({ hp, testid }) => (
  <span className="inline-flex items-center gap-1 rounded-md bg-purple-600 px-2 py-0.5 text-[11px] font-bold text-white" data-testid={testid}><Hash className="w-3 h-3" /> HP {hp}</span>
);

export const resumoViabilidade = (d, por) => ({
  hp: d.hp, complementos: d.complementos, logradouro: d.logradouro, numero: d.numero, bairro: d.bairro, cep: d.cep, cidade: d.cidade, uf: d.uf,
  codificacao: d.codificacao, servicos: d.servicos, vendaveis: d.vendaveis, consultado_em: d.consultado_em, consultado_por: por,
});
